import { Transaction } from '@multiversx/sdk-core/out';
import { TransactionManager } from '@multiversx/sdk-dapp/out/managers/TransactionManager';
import { getAccountProvider } from '@multiversx/sdk-dapp/out/providers/helpers/accountProvider';
import { TransactionsDisplayInfoType } from '@multiversx/sdk-dapp/out/types/transactions.types';

export { getTransactions } from '@multiversx/sdk-dapp/out/apiCalls/transactions/getTransactions';
export { initApp } from '@multiversx/sdk-dapp/out/methods/initApp/initApp';
export { setAxiosInterceptors } from '@multiversx/sdk-dapp/out/utils/network/setAxiosInterceptors';
export { getAccountProvider } from '@multiversx/sdk-dapp/out/providers/helpers/accountProvider';
export { GAS_PRICE } from '@multiversx/sdk-dapp/out/constants/mvx.constants';

export const logout = async () => {
  const provider = getAccountProvider();
  await provider.logout();
};

interface SignAndSendTransactionsProps {
  transactions: Transaction[];
  transactionsDisplayInfo?: TransactionsDisplayInfoType;
}

export const signAndSendTransactions = async ({
  transactions,
  transactionsDisplayInfo
}: SignAndSendTransactionsProps) => {
  const provider = getAccountProvider();
  const txManager = TransactionManager.getInstance();

  const signedTransactions = await provider.signTransactions(transactions);
  const sentTransactions = await txManager.send(signedTransactions);

  const sessionId = await txManager.track(sentTransactions, {
    transactionsDisplayInfo
  });

  return sessionId;
};
